<div class="flex flex-col gap-5">
  <h1 class="mb-4">Zarządzanie użytkownikami</h1>

  <app-info-message class="block mb-4 info-message-top-align">
    <div class="flex flex-col gap-2 text-[15px] text-[#334155]">
      <p class="m-0">
        <span class="font-bold">W celu wyszukania użytkownika należy:</span>
      </p>
      <ol class="m-0 pl-5 list-decimal">
        <li>Podać numer <span class="font-bold">PESEL</span> lub</li>
        <li>
          Podać <span class="font-bold">Imię</span> i
          <span class="font-bold">Nazwisko</span> oraz jedną z poniższych
          danych:
          <ol class="pl-5 mt-1 list-[lower-alpha]">
            <li>Seria i numer dokumentu tożsamości</li>
            <li>Data urodzenia</li>
            <li>Adres e-mail</li>
            <li>Miejscowość z adresu zamieszkania</li>
          </ol>
        </li>
      </ol>
      <p class="m-0">
        Po wprowadzeniu parametrów wyszukiwania należy wskazać powód
        wyszukiwania danego użytkownika.
      </p>
      <p class="m-0">
        <span class="font-bold">W celu wyświetlenia listy administratorów systemu</span>
         należy zaznaczyć pole wyboru „Administrator systemu”.
      </p>
    </div>
  </app-info-message>

  <div class="user-panel-card bg-white p-4" [formGroup]="searchForm">
    <div class="user-panel-section-title mb-3">Filtrowanie zaawansowane</div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div class="flex flex-col gap-2">
        <label for="user-pesel" class="user-panel-label">PESEL</label>
        <input
          id="user-pesel"
          pInputText
          formControlName="pesel"
          appControlError
        />
      </div>
      <div class="flex flex-col gap-2">
        <label for="user-first-name" class="user-panel-label">Imię</label>
        <input
          id="user-first-name"
          pInputText
          formControlName="firstName"
          appControlError
        />
      </div>
      <div class="flex flex-col gap-2">
        <label for="user-last-name" class="user-panel-label">Nazwisko</label>
        <input
          id="user-last-name"
          pInputText
          formControlName="lastName"
          appControlError
        />
      </div>
      <div class="flex flex-col gap-2">
        <label for="user-document-number" class="user-panel-label">
          Seria i numer dowodu tożsamości
        </label>
        <input
          id="user-document-number"
          pInputText
          formControlName="documentNumber"
          appControlError
        />
      </div>
      <div class="flex flex-col gap-2">
        <label for="user-birth-date" class="user-panel-label"
          >Data urodzenia</label
        >
        <p-date-picker
          id="user-birth-date"
          inputId="user-birth-date"
          formControlName="birthDate"
          dateFormat="yy-mm-dd"
          appendTo="body"
          class="w-full customDatePicker"
          [showIcon]="true"
          [iconDisplay]="'input'"
          [maxDate]="today"
          appControlError
        ></p-date-picker>
      </div>
      <div class="flex flex-col gap-2">
        <label for="user-email" class="user-panel-label">Adres e-mail</label>
        <input
          id="user-email"
          pInputText
          formControlName="email"
          appControlError
        />
      </div>
      <div class="flex flex-col gap-2">
        <label for="user-city" class="user-panel-label"
          >Miejscowość z adresu zamieszkania</label
        >
        <input
          id="user-city"
          pInputText
          formControlName="city"
          placeholder="Wprowadź nazwę miejscowości (min. 3 znaki)"
          ariaLabel="Miejscowość z adresu zamieszkania"
          appControlError
        />
      </div>
      <div class="flex flex-col gap-2">
        <span id="user-reason-label"
              class="user-panel-label"
              appRequiredLabel="reason"
          >Powód wyszukiwania</span
        >
        <p-select
          id="user-reason"
          inputId="user-reason"
          [options]="reasonOptions"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          formControlName="reason"
          ariaLabelledBy="user-reason-label"
          appControlError
          placeholder="Wybierz powód"
        ></p-select>
      </div>
      <div class="flex items-center gap-2">
        <p-checkbox
          id="system-administrator"
          inputId="system-administrator"
          formControlName="systemAdministrator"
          [binary]="true"
          styleClass="customCheckbox"
          (onChange)="onSystemAdministratorChange($event.checked)"
        ></p-checkbox>
        <label for="system-administrator" class="user-panel-label">
          Administrator systemu
        </label>
      </div>
      <div class="flex flex-col gap-2 md:col-span-3 md:items-end">
        <div class="flex flex-col gap-2 sm:flex-row sm:justify-end">
          <p-button
            type="button"
            label="Wyczyść filtry"
            styleClass="customInfoButton outlined"
            (click)="onClearFilters()"
          ></p-button>
          <p-button
            type="button"
            label="Wyszukaj"
            styleClass="customInfoButton"
            [disabled]="searchForm.controls.reason.invalid"
            (click)="onSearch()"
          ></p-button>
        </div>
      </div>
    </div>

    <div
      class="mt-2"
      appControlError
      [customErrorInput]="searchForm"
      [isInvalidCondition]="
        searchForm.invalid && (searchForm.dirty || searchForm.touched)
      "
    ></div>
  </div>

  <fieldset class="wide">
    <legend class="sr-only">Lista użytkowników</legend>
    <p-table
      #table
      class="user-table"
      [lazy]="true"
      [value]="rows()"
      [loading]="isDataLoading()"
      [rows]="tablePage()?.size || 10"
      [totalRecords]="tablePage()?.totalElements || 0"
      stripedRows
      dataKey="id"
      sortField="lastName"
      sortMode="single"
      [sortOrder]="1"
      (onSort)="onPrimeSortChange($event)"
    >
      <ng-template #caption>
        <span class="sr-only"
          >Lista użytkowników dostępnych po wyszukaniu.</span
        >
      </ng-template>
      <ng-template #header>
        <tr>
          <th pSortableColumn="firstName">
            <span class="inline-flex items-center gap-1.5">
              Imię
              <p-sortIcon field="firstName"></p-sortIcon>
            </span>
          </th>
          <th pSortableColumn="lastName">
            <span class="inline-flex items-center gap-1.5">
              Nazwisko
              <p-sortIcon field="lastName"></p-sortIcon>
            </span>
          </th>
          <th pSortableColumn="email">
            <span class="inline-flex items-center gap-1.5">
              Adres e-mail
              <p-sortIcon field="email"></p-sortIcon>
            </span>
          </th>
          <th pSortableColumn="lastLoginAt">
            <span class="inline-flex items-center gap-1.5">
              Data ostatniego logowania
              <p-sortIcon field="lastLoginAt"></p-sortIcon>
            </span>
          </th>
          <th>Akcje</th>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td class="table-filter-cell">
            <p-date-picker
              (onClear)="onPrimeFilterChange($event, 'lastLoginAt')"
              (onSelect)="onPrimeFilterChange($event, 'lastLoginAt')"
              [readonlyInput]="true"
              [showClear]="true"
              appendTo="body"
              class="w-full customDatePicker"
              dateFormat="dd-mm-yy"
              [(ngModel)]="tableFilters.lastLoginAt"
              [showIcon]="true"
              [iconDisplay]="'input'"
              ariaLabel="Filtruj po dacie ostatniego logowania"
            />
          </td>
          <td></td>
        </tr>
      </ng-template>
      <ng-template #body let-row>
        <tr>
          <td>{{ row.firstName }}</td>
          <td>{{ row.lastName }}</td>
          <td>{{ row.email }}</td>
          <td>{{ row.lastLoginAt | date: 'yyyy-MM-dd HH:mm' }}</td>
          <td class="text-center">
            <p-button
              type="button"
              ariaLabel="Zobacz szczegóły użytkownika"
              pTooltip="Zobacz szczegóły"
              tooltipPosition="top"
              [rounded]="true"
              [text]="true"
              (click)="showDetails(row)"
            >
              <i class="pi pi-eye icon" aria-hidden="true"></i>
            </p-button>
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="5" class="text-center p-4 text-sm text-gray-500">
            @if (hasSearched()) {
              Brak danych.
            } @else {
              Brak danych. W celu wyświetlenia danych o
              użytkowniku podaj niezbędne dane potrzebne do identyfikacji.
            }
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="flex items-center justify-end mt-3">
      <p-paginator
        (onPageChange)="onPrimePageChange($event)"
        [rows]="tablePage()?.size || 10"
        [totalRecords]="tablePage()?.totalElements || 0"
        [rowsPerPageOptions]="[5, 10, 20]"
      ></p-paginator>
    </div>
  </fieldset>

  <fieldset class="narrow">
    <legend class="sr-only">Lista użytkowników</legend>
    <div class="flex flex-col gap-4">
      @for (row of rows(); track row.id) {
        <p-card class="overflow-hidden">
          <div class="flex flex-col gap-3">
            <app-preview-data-wrapper
              label="Imię"
              [data]="row.firstName"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Nazwisko"
              [data]="row.lastName"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Adres e-mail"
              [data]="row.email"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Data ostatniego logowania"
              [data]="row.lastLoginAt"
              [dataType]="PreviewDataType.DATE_TIME"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <div class="flex justify-end pt-1">
              <p-button
                type="button"
                label="Zobacz szczegóły"
                styleClass="customInfoButton outlined"
                (click)="showDetails(row)"
              ></p-button>
            </div>
          </div>
        </p-card>
      }

      @if (rows().length === 0) {
        <p-card class="overflow-hidden">
          <div class="text-center text-sm text-gray-500 py-4">
            @if (hasSearched()) {
              Brak danych.
            } @else {
              Brak danych. W celu wyświetlenia danych o
              użytkowniku podaj niezbędne dane potrzebne do identyfikacji.
            }
          </div>
        </p-card>
      }

      <div class="flex items-center justify-end overflow-x-auto">
        <p-paginator
          (onPageChange)="onPrimePageChange($event)"
          [rows]="tablePage()?.size || 10"
          [totalRecords]="tablePage()?.totalElements || 0"
          [rowsPerPageOptions]="[5, 10, 20]"
        ></p-paginator>
      </div>
    </div>
  </fieldset>
</div>
